// Extraction service writes only the URL-encoded basename in evidence.source,
// while CaseDocument.url is the full Azure Blob URL — compare last path segment.
export function evidenceSourceMatchesDocumentUrl(
  source: string | null | undefined,
  docUrl: string | null | undefined,
): boolean {
  if (!source || !docUrl) return false;
  return lastPathSegment(source) === lastPathSegment(docUrl);
}

function lastPathSegment(value: string): string {
  return value.split('/').pop() ?? value;
}
